export default __webpack_public_path__ + "static/media/money_shot.95ddd32a.mp3";